<a class="shortcut-menu__button" href="https://fn-beheer.nfv.surf.net/p/login/" target="_blank">
  <svg-icon src="assets/images/icons/out.svg"></svg-icon>
  <span>{{ "ShortcutMenu.FortiManager" | translate }} </span>
</a>
